import Image from '@public/images/fintech-public-analytics.png'

import TextWithImageGoingOffScreen from '@/components/TextWithImageGoingOffScreen/TextWithImageGoingOffScreen'

export default function FintechAnalytics() {
    return (
        <TextWithImageGoingOffScreen
            title={`Out-of-the-box emission analytics`}
            paragraph={`Grow monthly active users with Lune’s decision-useful customer analytics page. Accelerate their sustainability goals by pinpointing emission hotspots, mapping carbon intensity, and showing the impact of their decarbonisation efforts.`}
            img={Image}
        />
    )
}
